import axios from 'axios';
const api = axios.create({
  baseURL: process.env.REACT_APP_API_PRJ_URL_data,   
});
export default api;